import React, { useEffect, useState, useRef, useMemo } from "react";
import styles from "./Explore.module.scss";
import { RowFlex } from "../../components/flex/RowFlex";
import { SwitchToggleButton } from "../../components/buttons/ToggleButton";
import icons from "../../../src/assets/images/icons";
import { HorizontalFlex } from "../../components/flex/HorizontalFlex";
import { VerticalFlex } from "../../components/flex/VerticalFlex";
import {BottomSheetSelect, DropdownSelect ,PopoverChipSelect, RangeSelect,AllSelect , RangeSection,SelectOrRange, RegionSelector} from "../../components/select/Select";
import { IconButton } from "../../components/buttons/IconButton";
import { MenuTab } from "../../components/tab/Tab";
import { requestEstateExploreList,requestCenterPnu, requestCenterAddress, requestRegion, requestRegionLatLng, requestRegionByPnu, requestEstateExploreMap} from "../../services/estateExplore/estateExploreService.js";
import  EstateCard from "../../components/card/Sale.jsx"
import UnitRangeSlider from "../../components/input/RangeInput.jsx";
import InfiniteScrollList from "../../components/dataview/List.jsx";
import legacy, { ExplorerMarker, g_price_markers } from '../../utils/legacy';
import { requestUpdateAddressOpen } from "../../services/estateManage/estateManageService.js";
import { v4 as uuidv4 } from 'uuid';

const EstateFilterModel = {
    
    estateUseArea: {
      label: "용도 지역",
      groups: [
        {
          label: "주거용",
          options:[
            {value: 1, label: "1종 전용 주거"},
            {value: 2, label: "2종 전용 주거"},
            {value: 3, label: "1종 일반 주거"},
            {value: 4, label: "2종 일반 주거"},
            {value: 5, label: "3종 일반 주거"},
            {value: 6, label: "준 주거"},
          ]
        },
        { 
          label: "상업용",
          options:[
            {value: 7, label: "중심 상업"},
            {value: 8, label: "일반 상업"},
            {value: 9, label: "근린 상업"},
            {value: 10, label: "유통 상업"},
          ]
        },
        { 
          label: "공업용",
          options:[
            {value: 11, label: "전용 공업"},
            {value: 12, label: "일반 공업"},
            {value: 13, label: "준 공업"},
          ]
        },
        { 
          label: "기타",
          options:[
            {value: 14, label: "보전 녹지"},
            {value: 15, label: "생산 녹지"},
            {value: 16, label: "자연 녹지"},
            {value: 17, label: "보전 관리"},
            {value: 18, label: "생산 관리"},
            {value: 19, label: "계획 관리"},
            {value: 20, label: "농림"},
            {value: 21, label: "자연환경 보전"},
          ]
        },
      ],
    },

    estateCategory: {
        label: '부동산 유형',
        options: [
            { value: "0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19", label: "전체" , icon:icons.estateType.all},
            { value: "12", label: "상업용건물", icon:icons.estateType.commercial},
            { value: "16", label: "토지" , icon:icons.estateType.land},
            { value: "10, 11", label: "상가/사무실", icon:icons.estateType.market},
            { value: "17, 18, 19", label: "공장/창고", icon:icons.estateType.factory},
            { value: "3,4,5,6", label: "단독/다가구", icon:icons.estateType.single},
            { value: "0, 1", label: "아파트", icon:icons.estateType.apartment},
            { value: "2", label: "오피스텔", icon:icons.estateType.officetell},
            { value: "7, 8", label: "연립/다세대", icon:icons.estateType.group},
            { value: "15", label: "숙박시설", icon:icons.estateType.accommondation},
        ],
    },
    estateType: {
        label: '부동산 유형',
        options: [
            { value: 16, label: "토지" },
            { value: 12, label: "상업용건물" },
            { value: 10, label: "상가점포" },
            { value: 11, label: "사무실" },
            { value: 2, label: "오피스텔" },
            { value: 17, label: "공장" },
            { value: 19, label: "창고" },
            { value: 18, label: "지식산업센터" },
            { value: 15, label: "숙박시설" },
            { value: 0, label: "아파트" },
            { value: 1, label: "주상복합" },
            { value: 7, label: "연립" },
            { value: 8, label: "다세대" },
            { value: 3, label: "단독" },
            { value: 4, label: "다가구" },
            { value: 6, label: "상가주택" },
            { value: 5, label: "전원주택" },
            { value: 14, label: "기타건물" },
        ],
    },
    priceRange: {
        label: '가격 범위',
        options: [
            { value: 2, label: '1억 이하' },
            { value: 3, label: '1억 ~ 5억' },
            { value: 4, label: '5억 ~ 10억' },
            { value: 5, label: '10억 이상' }
        ],
    },
    areaSize: {
        label: '면적',
        options: [
            { value: 2, label: '30㎡ 이하' },
            { value: 3, label: '30㎡ ~ 50㎡' },
            { value: 4, label: '50㎡ ~ 100㎡' },
            { value: 5, label: '100㎡ 이상' }
        ],
    },
    dealType: {
        label: '거래 유형',
        options: [
            { value: 0, label: '매매' },
            { value: 1, label: '전세' },
            { value: 2, label: '월세' }
        ],
    },
    location: {
        label: '지역',
        options: [
            { value: '서울', label: '서울' },
            { value: '경기', label: '경기' },
            { value: '부산', label: '부산' },
            { value: '대구', label: '대구' },
            { value: '광주', label: '광주' }
        ],
    },
    addressOpen: {
        label: '위치공개',
        options: [
            { value: 1, label: '위치공개' },
            { value: 0, label: '위치비공개' },
        ],
    },
    state: {
        label: '노출상태',
        options: [
            { label: "전체", icon: { selected: icons.saleState.total.on, default: icons.saleState.total.off }, value: '' },
            { label: "노출중", icon: { selected: icons.saleState.visible.on, default: icons.saleState.visible.off }, value: 0 },
            { label: "비노출중", icon: { selected: icons.saleState.invisible.on, default: icons.saleState.invisible.off }, value: 3 },
            { label: "거래완료", icon: { selected: icons.saleState.done.on, default: icons.saleState.done.off }, value: 1 },
        ]
    },
    order: {
        label: "정렬",
        options: [
            { label: "최신순", value: { type: "creation_date", order: "increase" } },
            { label: "오래된 순", value: { type: "creation_date", order: "decrease" } },
            { label: "가격높은순", value: { type: "price", order: "increase" } },
            { label: "가격낮은순", value: { type: "price", order: "decrease" } },
        ]
    },
    limit: {
        label: '',
        options: [
            { label: "20개씩 보기", value: 20 },
            { label: "30개씩 보기", value: 30 },
            { label: "50개씩 보기", value: 50 },
        ]
    }

};


const Full = ({ children }) => {
  return <div className={styles.fullLayout}>{children}</div>;
};

const SideLayout = ({ children, ref }) => {
  return <div className={styles.sideLayout} {...(ref ? { ref } : {})}>{children}</div>;
};

const MainLayout = ({ children}) => {
  return <div className= {styles.mainLayout} >{children}</div>
}

const HeaderLayout = ({ children }) => {
  return <div className={styles.headerLayOut}>{children}</div>;
};
const BottomLayout = ({ children }) => {
  return <div className = {styles.bottomLayOut}>{children}</div>
}

const RegionContainer = ({selectedRegion, onChange}) => {

  const [regionDB, setRegionDB] = useState([]);
  const [open, setOpen] = useState(false);

  const [sigunguList, setSigunguList] = useState([]);
  const [dongList, setDongList] = useState([]);
 
  const buttonRef = useRef(null);
  const popupRef = useRef(null);

  useEffect(() => {
    const fetchRegionData = async () => {
      try {
        const result = await requestRegion();
        setRegionDB(result.regionDB);
      } catch (err) {
        console.error("지역 데이터 로딩 실패", err);
      }
    };
  
    fetchRegionData();
  }, []);

  const handleSidoSelect = (sido) => {
    const matched = regionDB.find(r => r.sido === sido);
    onChange({ sido, gungu: '', dong: '' });
    setSigunguList(matched.sigungu);
    setDongList([]);
  };

  const handleGunguSelect = (gungu) => {
    const matchedGungu = sigunguList.find(g => g.gungu === gungu);
    onChange(prev => ({ ...prev, gungu, dong: '' }));
    setDongList(matchedGungu.dongs);
  };

  const handleDongSelect = async(dong) => {

    const updated = {...selectedRegion, dong}
    onChange(updated);
    setOpen(false);

    try {
      const result = await requestRegionLatLng(updated);
      legacy.setInitGroupViewMap([result.latlng]);
    } catch (err) {
      console.error("위치 이동 실패", err);
    }

  };

  const handleConfirmBtn = async() => {
    setOpen(false);
    const result = await requestRegionLatLng(selectedRegion)
    legacy.setInitGroupViewMap([result.latlng]);
  }

   useEffect(() => {
    if (open && buttonRef.current && popupRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      console.log(buttonRef)
      console.log(buttonRect)
      popupRef.current.style.top = `${buttonRect.bottom + 8}px`;
      popupRef.current.style.left = `${buttonRect.left}px`;
    }
  }, [open]);

  return <div className={styles.regionContainer}>
          <div className = {styles.regionButton} onClick={() => setOpen(!open)}  ref={buttonRef}>
              <div>
                {selectedRegion.sido || '시/도'}
              </div>
              {selectedRegion.gungu && (
                <>
                  <div>&gt;</div>
                  <div>{selectedRegion.gungu}</div>
                </>
              )}

              {selectedRegion.dong && (
                <>
                  <div>&gt;</div>
                  <div>{selectedRegion.dong}</div>
                </>
              )}
          </div>
          {open && (
          <div className={styles.regionPopup} ref={popupRef}>
            <div className={styles.title}>지역 바로가기</div>
            <div className={styles.columns}>
            <div className={styles.column}>
              {regionDB.map((r, idx) => (
                <div
                  key={idx}
                  className={`${styles.item} ${selectedRegion.sido === r.sido ? styles.selectedRegion : ''}`}
                  onClick={() => handleSidoSelect(r.sido)}
                >
                  {r.sido}
                </div>
              ))}
            </div>
            <div className={styles.column}>
              {sigunguList.map((g, idx) => (
                <div
                  key={idx}
                  className={`${styles.item} ${selectedRegion.gungu === g.gungu ? styles.selectedRegion : ''}`}
                  onClick={() => handleGunguSelect(g.gungu)}
                >
                  {g.gungu}
                </div>
              ))}
            </div>
            <div className={styles.column}>
              {dongList.map((d, idx) => (
                <div
                  key={idx}
                  className={`${styles.item} ${selectedRegion.dong === d ? styles.selectedRegion : ''}`}
                  onClick={() => handleDongSelect(d)}
                >
                  {d}
                </div>
              ))}
            </div>
          </div>
          <div className={styles.confirmButton} onClick={() => handleConfirmBtn()}>
            {selectedRegion.sido} {selectedRegion.gungu} {selectedRegion.dong} 으로 이동
          </div>
        </div>
      )}
    </div>

}

const getOverlay = () => {
  var dspmp = new legacy.DiscoSubPageModeParams();
  dspmp.forwardEvent = true;
  dspmp.helloCallback = function () {
  }
  dspmp.byeCallback = function () {
      if (legacy.estateMarkerAjax != null) {
          legacy.estateMarkerAjax.abort();
          legacy.estateMarkerAjax = null;
      }
      if (legacy.timer_redraw != null) {
          clearTimeout(legacy.timer_redraw);
          legacy.timer_redraw = null;
      }
      if (legacy.timer_area_redraw != null) {
          clearTimeout(legacy.timer_area_redraw);
          legacy.timer_area_redraw = null;
      }
      if (legacy.timer_redraw_overlay_cluster != null) {
          clearTimeout(legacy.timer_redraw_overlay_cluster);
          legacy.timer_redraw_overlay_cluster = null;
      }
      legacy.clear_map();
      legacy.reload(false);
  }
  return new legacy.DiscoSubPageMode(dspmp);
}

function click_sale_marker(selectedGroupKey) {
  for (var group_key in g_price_markers) {
      if (selectedGroupKey == group_key ) {
        g_price_markers[group_key]['marker'].setContent(ExplorerMarker.clicked(g_price_markers[group_key]));
      } else {
        if (legacy.jQuery(g_price_markers[group_key]['marker'].getContent()).data("status") == "clicked") {
          g_price_markers[group_key]['marker'].setContent(ExplorerMarker.default(g_price_markers[group_key]));
        }
      } 
  }
}

function click_cluster_marker(selectedChunkKey) {
  for (var chunk_key in g_price_markers) {
      if (selectedChunkKey == chunk_key ) {
        g_price_markers[chunk_key]['marker'].setContent(ExplorerMarker.cluster_clicked(g_price_markers[chunk_key]));
      } else {
        if (legacy.jQuery(g_price_markers[chunk_key]['marker'].getContent()).data("status") == "clicked") {
          g_price_markers[chunk_key]['marker'].setContent(ExplorerMarker.cluster(g_price_markers[chunk_key]));
        }
      } 
  }
}


const OverlayMode = (sideviewRef, callLoadSelectedGroup) => {
  var dspmp = new legacy.DiscoSubPageModeParams();


  function clickSingleMarker(group_key, suid) {
    const markerData = g_price_markers[group_key];
  
    callLoadSelectedGroup({ group_key });
  
    if (suid) {
      legacy.open_sale_to_sideview(sideviewRef, suid, {
        handler: {
          show: () => {
            if (markerData?.marker?.getPosition) {
              legacy.discoMap.panTo(markerData.marker.getPosition());
            }
            click_sale_marker(group_key);
          },
          close: () => {
            if (markerData?.marker?.setContent) {
              markerData.marker.setContent(ExplorerMarker.default(markerData));
            }
          }
        }
      });
    } else {
      const event = new CustomEvent('close');
      sideviewRef.dispatchEvent(event);
      if (markerData?.marker?.getPosition) {
        legacy.discoMap.panTo(markerData.marker.getPosition());
      }
      click_sale_marker(group_key);
    }
  }
  

  function clickClusterMarker(clusterId) {
    const marker = g_price_markers[clusterId];
  
    if (marker) {
      const sw = new kakao.maps.LatLng(marker.sw_lat, marker.sw_lng);
      const ne = new kakao.maps.LatLng(marker.ne_lat, marker.ne_lng);
      const bounds = new kakao.maps.LatLngBounds(sw, ne);
      legacy.discoMap.setBounds(bounds, {top : 156});
    }
  
    callLoadSelectedGroup({
      swLat: marker?.sw_lat,
      swLng: marker?.sw_lng,
      neLat: marker?.ne_lat,
      neLng: marker?.ne_lng,
    });
  
    click_cluster_marker(clusterId);
  }
  

  dspmp.kakaoEvent.mapClick = function (mouseEvent) {

  }

  dspmp.kakaoEvent.zoom_changed = () => {

  }

  dspmp.kakaoEvent.dragend = function () {
      legacy.drag_end = new Date().getTime();
  }

  dspmp.discoMarkerClickEvent.stagePin = function (selector) {
    const $selector = legacy.jQuery(selector);
      var uuid = $selector.data('uuid');
      var suid = $selector.data('suid');

      if (g_price_markers.hasOwnProperty(uuid)) {
        const marker_type = $selector.data('type');
        if (marker_type == "single") {
          clickSingleMarker(uuid, suid);
        } else if (marker_type == 'cluster'){
          clickClusterMarker(uuid);
        }
      }
  }

  dspmp.discoMarkerClickEvent.mapAgentMarker = () => { }

  //마커추가

  dspmp.discoMapEvent.addPriceMarker = function (data) {
      const r =  data[0];

      if (r.type == 'cluster') {
        var content = ExplorerMarker.cluster(r);;
      } else {
        var content = ExplorerMarker.default(r);;
      }

      var overlay = new legacy.daum.maps.CustomOverlay({
          position: new legacy.daum.maps.LatLng(r['lat'], r['lng']),
          clickable: false,
          content: content,
          zIndex: 3,
          xAnchor: 0.5,
          yAnchor: 1
      });
      overlay.setMap(legacy.map);
      return overlay;
  }

  dspmp.discoMapEvent.currentAgentMarker = () => { }

  dspmp.discoMapEvent.reload = async function () {

  }

  return dspmp;
}

const ExplorePage = ({
  isMobile = false,
  state = "",
  
}) => {
  const RESET_FILTER = useMemo(() => ({
    deal_type: [],           // 0: 매매, 1: 전세, 2: 월세
    randType : [],
    useArea : [],
    minPrice: null,           // 최소 가격
    maxPrice: null,           // 최대 가격
    minMonthly: null,           // 최소 가격
    maxMonthly: null,           // 최대 가격
    minDeposit: null,           // 최소 가격
    maxDeposit: null,           // 최대 가격
    minArea: null,            // 최소 면적
    maxArea: null,            // 최대 면적
  }), [])

  const overlay = useRef(null);

  const [payload, setPayload] = useState({...RESET_FILTER});
  const payloadRef = useRef(payload);
  const [hasMore, setHasMore] = useState(true);
  const LIMIT = 20;
  const [offset, setOffset] = useState(0);
  const [data, setData] = useState({
   list: [],
   count: 0,
   totalCount: 0,
  });

  const listRef = useRef();
  const extraParamsRef = useRef({}); // 부가 파라미터 저장용

  const getDefaultBound = () => {
    const bounds = legacy.discoMap.getBounds();
    return {
      swLat: bounds.getSouthWest().getLat(),
      swLng: bounds.getSouthWest().getLng(),
      neLat: bounds.getNorthEast().getLat(),
      neLng: bounds.getNorthEast().getLng(),
    };
  };

  const handlePayload = (key, value) => {
    setPayload(prev => {
        if (prev[key] !== value) {
          setIsMove(true);
          return {
                ...prev,
                [key]: value,
            };
        }
        return prev; 
    });
  };
  
  const handleResetPayload = () => {
    setIsMove(true);
    setPayload((prev) => ({ ...RESET_FILTER }))
  }

  const sideviewRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);

  const estateListWithId = useMemo(() =>
    data.list.map((d, idx) => ({
      ...d,
      id: d.suid || d.id || d.group_key || uuidv4()
    })), [data.list]
  );

  const fetchList = async (payload) => {
    setIsLoading(true);
    try {
      const result = await requestEstateExploreList(payload);
      if (payload.offset == 0) {
        listRef.current?.scrollToTop();
        setData({
          list: result.data,
          count: result.count,
          totalCount: result.totalCount,
        })
      } else {
        setData(prev => ({
          list: [...prev.list, ...result.data],
          count: result.count,
          totalCount: result.totalCount,
        }));
      }
      if (result.count < payload.limit) setHasMore(false);
    } catch (err) {
      // 에러 핸들링 필요시 추가
    } finally {
      setIsLoading(false);
    }
  };

  const fetchMap = async (payload) => {
    try {
      const result = await requestEstateExploreMap(payload);
      legacy.clear_map();
      legacy.redraw(result.data, 0);
    } catch (err) {
      console.warn(err);
    }
  };

  const loadData = (payload, customOffset = offset) => {
      const bounds = legacy.discoMap.getBounds();
      const sw = bounds.getSouthWest();
      const ne = bounds.getNorthEast();
      const center = legacy.discoMap.getSltCenter();
      const map_lv = legacy.map.getLevel();
      const data = {
        ...payload,
        offset : customOffset,
        limit : LIMIT,
        swLat : sw.getLat(),
        swLng : sw.getLng(),
        neLat : ne.getLat(),
        neLng : ne.getLng(),
        map_lv : map_lv,
        centerLat: center.getLat(),
        centerLng: center.getLng(),        // 지도 중심 경도
    }
    fetchList(data);
    fetchMap(data);
  }

  const requsetGroupData = (payload, options={}) => {
    setIsMove(true);    
    setOffset(prevOffset => {
      fetchList({
        ...payload,
        offset : 0,
        limit : 20,
        ...options
      });
      return 0;
    });
  };

const selectedDealTypes = useMemo(() => payload.deal_type, [payload.deal_type]);
const selectedUseArea = useMemo(() => payload.useArea, [payload.useArea]);

const getFilterSummaryLabel = (selectedValues,
  allOptions,
  defaultLabel,
  allLabel = '전체'
  ) => {

  if (!selectedValues || selectedValues.length === 0) return defaultLabel;

  const allValues = allOptions.map(opt => opt.value).sort();
  const selectedSorted = [...selectedValues].sort();

  const isAllSelected =
    selectedValues.length === allValues.length &&
    allValues.every((val, idx) => val === selectedSorted[idx]);

  if (isAllSelected) return allLabel;

  const sortedSelectedOptions = allOptions.filter(opt => selectedValues.includes(opt.value));

  if (sortedSelectedOptions.length === 1) {
    return sortedSelectedOptions[0].label;
  }

  const firstLabel = sortedSelectedOptions[0].label;
  const additionalCount = sortedSelectedOptions.length - 1;

  return `${firstLabel} +${additionalCount}`;
};

const formatPriceUnit = (price) => {
  const p = Number(price);
  if (isNaN(p)) return '';

  if (p >= 10000) {
    return `${(p / 10000).toFixed(1).replace(/\.0$/, '')}억`;
  } else if (p >= 1000) {
    return `${(p / 1000).toFixed(1).replace(/\.0$/, '')}천만`;
  } else {
    return `${p}만`;
  }
};

const getPricePlaceholder = () => {
  const { minPrice, maxPrice, minDeposit, maxDeposit, minMonthly, maxMonthly } = payload;

  const 보 =
    minDeposit || maxDeposit
      ? `보 ${formatPriceUnit(minDeposit)}${maxDeposit ? `~${formatPriceUnit(maxDeposit)}` : '~'}`
      : '';

  const 월 =
    minMonthly || maxMonthly
      ? `월 ${formatPriceUnit(minMonthly)}${maxMonthly ? `~${formatPriceUnit(maxMonthly)}` : '~'}`
      : '';

  const 매 =
    minPrice || maxPrice
      ? `매 ${formatPriceUnit(minPrice)}${maxPrice ? `~${formatPriceUnit(maxPrice)}` : '~'}`
      : '';

  return [보, 월, 매].filter(Boolean).join(' ・ ') || '가격';
};

const hasSelectedFilters = (payload, keys = []) => {
  return keys.some((key) => {
    const value = payload[key];

    if (Array.isArray(value)) {
      return value.length > 0;
    }

    return value !== null && value !== undefined;
  });
};

const SelectComponent = isMobile ? BottomSheetSelect : PopoverChipSelect;

const renderEstateFilterContainer = () =>{

  const PriceSections = [
    {
      step:1000,
      rangeMaxLimit:10000,
      title: "보증금(전세금)",
      hasTitle: true,
      min: payload.minDeposit,
      max: payload.maxDeposit,
      maxLimit:100000,
      onMinChange: value => handlePayload("minDeposit", value),
      onMaxChange: value => handlePayload("maxDeposit", value),
    },
    {
      step:10,
      rangeMaxLimit:1000,
      title: "월세",
      hasTitle: true,
      min: payload.minMonthly,
      max: payload.maxMonthly,
      maxLimit:3000000,
      onMinChange: value => handlePayload("minMonthly", value),
      onMaxChange: value => handlePayload("maxMonthly", value),
    },
    {
      step:1000,
      rangeMaxLimit:10000,
      title: "매매",
      hasTitle: true,
      min: payload.minPrice,
      max: payload.maxPrice,
      maxLimit:2000000000,
      onMinChange: value => handlePayload("minPrice", value),
      onMaxChange: value => handlePayload("maxPrice", value),
    },
  ]

  const [areaUnit, setAreaUnit] = useState("평");

  const [minArea, setMinArea] = useState(30); // 초기값: 30평
  const [maxArea, setMaxArea] = useState(50);
  
  // 단위가 바뀌면 값을 변환해서 직접 상태를 변경
  const handleUnitChange = (newUnit) => {
    if (areaUnit === newUnit) return;

    const convert = (value, from, to) => {
      if (value == null) return null;
      if (from === "평" && to === "m²") return Math.round(value * 3.3058);
      if (from === "m²" && to === "평") return Math.round(value * 0.3025);
      return value;
    };

    setMinArea((prev) => convert(prev, areaUnit, newUnit));
    setMaxArea((prev) => convert(prev, areaUnit, newUnit));
    setAreaUnit(newUnit);
  };

  const handleRangeChange = (key, values) => {
    if (key == "area") {
      handlePayload("minArea", values[0]);
      handlePayload("maxArea", values[1]);      
    }
  }
  const [unitIndex, setUnitIndex] = useState(0);
  const unitOptions = [
    {
      label: 'm²',
      format: (v) => `${v}m²`,
      parse: (s) => parseFloat(s.replace(/[^0-9.]/g, '')),
    },
    {
      label: '평',
      format: (v) => `${(v / 3.3).toFixed(1)}평`,
      parse: (s) => parseFloat(s.replace(/[^0-9.]/g, '')) * 3.3,
    },
  ]

  const toggleUnit = () => setUnitIndex((prev) => (prev + 1) % unitOptions.length);
  return (
    <RowFlex  className={`${isMobile ? styles.mobileHeader : ''}`} gap='8px' style={{ width: 'fit-content' }}>
      
      {/* <AllSelect
        isIcon={true}
        src={icons.filter.black}
        blueSrc = {icons.filter.blue}
        isSelected = {hasSelectedFilters(payload, [
          'deal_type',
          'rand_type',
          'minPrice',
          'maxPrice',
          'minMonthly',
          'maxMonthly',
          'minDeposit',
          'maxDeposit',
          'minArea',
          'maxArea',
        ])}
      >
 
        <SelectOrRange
          type = "select"
          showAllOption = {true}
          allOptionLabel= '전체'
          options={EstateFilterModel.dealType.options}
          selected={selectedDealTypes}
          onChange={(value) => handlePayload('deal_type', value)}
          selectTitle = '거래유형'
        />
        <SelectOrRange
          type = "range"
          showAllOption = {true}
          allOptionLabel= '전체'
          sections = {PriceSections}
          unit = '만원'
        />
      </AllSelect>
       */}
      <IconButton
        width="40px"
        height="40px"
        onClick={handleResetPayload}
        src={icons.refresh.grey}
       />

      <SelectComponent
        label={EstateFilterModel.dealType.label}
          placeholder={getFilterSummaryLabel(payload.deal_type,
            EstateFilterModel.dealType.options,
            EstateFilterModel.dealType.label,
            '전체')}
          options={EstateFilterModel.dealType.options}
          selected={selectedDealTypes}
          multiple={true}
          showAllOption={true}
          onChange={(value) => handlePayload('deal_type', value)}
        allOptionLabel={'전체'}
      />

      <RangeSelect
        placeholder={getPricePlaceholder()}
          label = "가격"
          unit = "만원"
        sections={PriceSections}
      />
      <AllSelect
        placeholder={"면적"}
        label="면적"
        unitIndex={unitIndex}
        unitOptions={unitOptions}
        onToggleUnit={toggleUnit}
        isSelected={hasSelectedFilters(payload, ['minArea', 'maxArea'])}
      >
        <UnitRangeSlider
          min={0}
          max={1000}
          step = {1}
          values={[payload.minArea ?? 0, payload.maxArea ?? 1000]}
          onChange={(values) => handleRangeChange("area", values)}
          unitOptions={unitOptions}
          unitIndex = {unitIndex}
        />
      </AllSelect>
      
      <SelectComponent
        label={EstateFilterModel.estateUseArea.label}
          placeholder={getFilterSummaryLabel(payload.useArea,
            EstateFilterModel.estateUseArea.groups.flatMap(group => group.options),
            EstateFilterModel.estateUseArea.label,
            '전체')}
        options={EstateFilterModel.estateUseArea.groups.flatMap(group => group.options) }
        selected={selectedUseArea}
        multiple={true}
        showAllOption={true}
        onChange={(value) => handlePayload('useArea', value)}
        allOptionLabel={'전체'}
        isGroup={true}
        groups = {EstateFilterModel.estateUseArea.groups}
      />

    </RowFlex>
  );
}

useEffect(() => {
  handleMap(true);
  loadData(payloadRef.current);
return () => {
    handleMap(false);
};
}, [])

useEffect(() => {
  if (state.history == "show") {
      handleMap(true);
  } else if (state.history == "hide") {
      handleMap(false);
  }
}, [state]);

  useEffect(() => {
    if (data.count < data.totalCount && data.count !== 0 && data.count % 20 === 0) {
      setHasMore(true);
    } else {
      setHasMore(false);
    }

  }, [data]);


  useEffect(() => {
      payloadRef.current = payload;
    }, [payload]);

  const onLoad = () => {
    if (!hasMore) return;
    setOffset(prevOffset => {
      const newOffset = prevOffset + LIMIT;
      // 부가 파라미터가 있으면 그것을, 아니면 기본 바운드 사용
      const extra = extraParamsRef.current;
      fetchList({
        ...payloadRef.current, 
        offset: newOffset,
        limit: LIMIT,
        ...extra 
      });

      return newOffset;
    });
  }

  const requestSelectedGroup = (options) => {
    // 그룹 바운드 등 부가 파라미터를 저장
    extraParamsRef.current = {
      ...options // 예: { swLat, swLng, neLat, neLng, ... }
    };
    requsetGroupData(payloadRef.current, options);
  }

  const requestLoadData = () => {
    setOffset(0);
    extraParamsRef.current  = getDefaultBound();
    loadData(payloadRef.current, 0);
    setIsMove(false); // 버튼 숨김
  }; 

  const handleMap = (isActive) => {
    if (isActive) {
        if (!overlay.current) overlay.current = getOverlay();
        legacy.tui_base_close();
        if (legacy.dsv) legacy.dsv.blockUpdateView(true);
        if (legacy.jQuery('#map_filter_box').is(':visible')) legacy.jQuery('#map_filter_box').css('display', 'none');
        if (legacy.jQuery('.map-name-card').is(':visible')) legacy.jQuery(".map-name-card").css('display', 'none')
        overlay.current?.autoAddListener(OverlayMode(sideviewRef.current, requestSelectedGroup));
        if (legacy.timer_redraw != null) {
            clearTimeout(legacy.timer_redraw);
            legacy.timer_redraw = null;
        }
        if (legacy.timer_area_redraw != null) {
            clearTimeout(legacy.timer_area_redraw);
            legacy.timer_area_redraw = null;
        }
        if (legacy.reload_area_ajax) {
            legacy.reload_area_ajax?.abort();
            legacy.reload_area_ajax = null;
        }
        legacy.clear_arch_polygons();
        legacy.clear_land_polygons();
        legacy.clear_map();
        legacy.reload(false);
    } else {
        legacy.tui_base_open();
        if (legacy.dsv) legacy.dsv.blockUpdateView(false);
        if (!legacy.jQuery('#map_filter_box').is(':visible')) legacy.jQuery('#map_filter_box').css('display', '');
        legacy.jQuery(".map-name-card").css('display', '')
        overlay.current?.exitMode?.();
        overlay.current = null;

    }

}

  const [selected, setSelected] = useState("0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19");
  const handleClosePage = () => {
    legacy.bh.go_before();
  }

  const [isMove, setIsMove] = useState(false);

  useEffect(() => {
    getCurrentAddress();
    
    const mapInstance = legacy.map;

    if (!mapInstance || typeof mapInstance.addListener !== 'function') {
      console.warn("카카오 지도 객체가 유효하지 않습니다.");
      return;
    }
  
    const handleIdle = () => {
      getCurrentAddress();
      setIsMove(true);
    };

    const handleZoomChanged = () => {
      getCurrentAddress();
      setIsMove(true);
    };
  
    mapInstance.addListener("idle", handleIdle);
    return () => {
      mapInstance.removeListener('idle', handleIdle);
    };
  
  }, []);



  
  const [selectedRegion, setSelectedRegion] = useState({
    sido: '',
    gungu: '',
    dong: ''
  });

  const getCurrentAddress = async() => {

    const center = legacy.discoMap.getSltCenter();
    const params = {
      lat: center.getLat(),
      lng: center.getLng()
    }
    const result = await requestCenterPnu(params); 
    const payload = {
      pnu : result.pnu,
      lv : legacy.map.getLevel()
    }
    const updated = { sido: '', gungu: '', dong: '' };
    const region = await requestRegionByPnu(payload)
    updated.sido = region.sido;
    updated.gungu = region.gungu;
    updated.dong = region.dong;
    setSelectedRegion(updated);
  }

  useEffect(() => {
    setOffset(0);
    loadData(payload, 0);
  }, [payload]);

  return (
    
    <div style={{width: '100%', height: '100%', overflow: 'hidden'}}>
      <Full>
        <SideLayout  ref={sideviewRef}> 
          <div className={styles.top}>
            <div className={styles.left} onClick={handleClosePage}>
              <img src={icons.back.black} className={styles.left} />
            </div>
            <div className={styles.center}>
              <div className={styles.discoLogo}>
                <img className={styles.logoIcon} src={icons.logo} />
              </div>
              <div className={styles.logoText}>
                <span className={styles.saleText}>매물</span>
              </div>
            </div>
            <div className={styles.right}>
              <img src={icons.search.black} className={styles.right} style={{visibility : 'hidden'}}/>
            </div>
          </div>

          {/* <HorizontalFlex
            className={styles.headerAddress}
            leftChildren={<h1 className={styles.hTag}>{currentAddress}</h1>}
            rightChildren={
              <div className={styles.rightHeaderAddressFont}>
                {payload.address}
              </div>
            }
            leftParentClassName={styles.leftHeaderAddress}
            rightParentClassName={styles.rightHeaderAddress}
          ></HorizontalFlex> */}

          <HorizontalFlex
            className={styles.realEstateFilter}
            leftChildren={<div className={styles.estateCount}>총 {data.totalCount} 개 매물</div>}
            rightChildren={<div>최신순</div>}
          ></HorizontalFlex>
          <div style={{overflow : 'hidden' , height : '100%', backgroundColor: '#fff'}}>
            {data.list.length === 0 ? (
              <div className={styles.emptyState}>
                <img src={icons.empty.list} alt="비어있음" className={styles.emptyImage} />
                <p className={styles.emptyText}>조건에 맞는 매물이 없어요<br />지도를 이동하거나 필터를 변경해보세요.</p>
              </div>
            ) : (
              <InfiniteScrollList
                ref={listRef}
                items={estateListWithId}
                renderItem={(d) => (
                  <EstateCard
                    {...d}
                    onClick={ (suid) => legacy.open_sale_to_sideview(sideviewRef.current, suid, {
                      containerStyle : {
                        marginTop : '63.5px'
                      },
                      handler: {
                        show: () => {
                          const marker = g_price_markers[d.marker_key]?.marker;
                          if (marker?.type == 'single') {
                            if (marker?.getPosition) discoMap.panTo(marker.getPosition());
                            click_sale_marker(d.marker_key);
                          } else {
                            discoMap.panTo( new daum.maps.LatLng(d.lat, d.lng));
                          }
                        },
                        close: () => {
                          const marker = g_price_markers[d.marker_key]?.marker;
                          if (marker?.type == 'single') {
                            if (marker?.setContent) {
                              marker.setContent(ExplorerMarker.default(g_price_markers[d.marker_key]));
                            }
                          }
                        }
                      }
                    } )}
                  />
                )}
                className={styles.estateList}
                onTrigger={onLoad}
                isLoading={isLoading}
                hasMore={hasMore}
              />
              )}
          </div>
          {/* <div  onClick = {legacy.D} style ={{width:'14px' , height: '38px', backgroundColor: 'rgba(0,0,0,0.4)' , top: '40%', left: '397px' , position:'absolute'}}>
            <img src = {icons.arrow.left.black} style={{}}></img>
            
          </div> */}
        </SideLayout>
        <MainLayout>
          <HeaderLayout>
              <HorizontalFlex
                className={styles.topHeader}
                leftChildren={<MenuTab
                  options={
                    EstateFilterModel.estateCategory.options
                    }
                  selected={selected}
                  onChange={(value) => {
                    handlePayload('rand_type', value);
                    setSelected(value);
                    setOffset(0);
                  }}
                />}
                leftParentClassName={styles.scrollContainer}
              //   rightChildren={<SwitchToggleButton
              //     onChange={() => {}}
              //     offLabel={"리스트 보기"}
              //     onLabel={"지도 보기"}
              // />}
              //   rightParentClassName="fixedRight"
              />
            <div className={styles.detailFilter}>
              { renderEstateFilterContainer() }

            </div>
            <RegionContainer
              selectedRegion={selectedRegion}
              onChange={setSelectedRegion}
            />
            
          </HeaderLayout>
          <BottomLayout>
              {isMove && (
                <button
                  className={styles.currentRefreshBtn}
                  onClick={requestLoadData}
                >
                  <div><img src={icons.list} alt="list" /></div>
                  <div>현재위치 매물확인</div>
                </button>
              )}
          </BottomLayout>
        </MainLayout>
      </Full>
    </div>
  );
};

export default ExplorePage;
